import React from 'react';
import Typography from '../../../basic/Typography';
import styles from '../NewNG.module.css';

export interface ListItem {
  id: string | number;
  time?: string;
  title: string;
  description?: string;
  isActive?: boolean;
}

interface ListPanelProps {
  title: string;
  items: ListItem[];
  className?: string;
  showTime?: boolean;
  showDescription?: boolean;
}

export const ListPanel: React.FC<ListPanelProps> = ({
  title,
  items,
  className = '',
  showTime = true,
  showDescription = true
}) => {
  return (
    <div className={`${styles['newng-timeline-panel']} ${className}`}>
      <Typography variant="news-subtitle" component="div" className={styles['newng-timeline-header']}>{title}</Typography>
      <div className={styles['newng-timeline']}>
        <div className={styles['newng-timeline-events']}>
          {items.map((item) => (
            <div
              key={item.id}
              className={`${styles['newng-timeline-event']} ${item.isActive ? styles['now-playing'] : ''}`}
            >
              {showTime && item.time && (
                <Typography variant="news-time" component="div" className={styles['newng-timeline-time']}>{item.time}</Typography>
              )}
              <div className={styles['newng-timeline-detail']}>
                <Typography variant="body1" component="div">{item.title}</Typography>
                {showDescription && item.description && (
                  <Typography variant="news-meta" component="div">{item.description}</Typography>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};